import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { PurchasePOIP, SaveStatusObj, SSOStatus, SOModule, SaveEventType, SalesOrder, ActualDateChange, ActualDateToken, PlannedDateToken } from '../../../shared/misc-classes';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DataService } from '../../../shared/dataservice.service';
import { ActualDateDialog } from '../../../dialogs/actual-date-dialog/actual-date-dialog';

@Component({
  selector: 'purchase-po',
  templateUrl: './purchase-po.component.html',
  styleUrls: ['./purchase-po.component.css']
})
export class PurchasePoComponent implements OnInit, OnChanges {

  @Input() purchasePOObj: PurchasePOIP;
  @Input() soLockObtained:boolean;
  @Input() loadCounter:SalesOrder;
  @Output() updateSubSalesOrder: EventEmitter<SaveStatusObj> = new EventEmitter();
  disableForm: boolean = true;
  hasAdditionalMessage :boolean = false;

  modifyPlanDate:boolean = false;
  modifyReqDate:boolean = false;
  Hvr:any = {};
  
  public _SSOStatus = SSOStatus;
  inputDisableMessage:string = 'This form is not yet enabled';
  additionalMesage: string = ''
  constructor(public _dataService: DataService, public dialog: MatDialog) {

  }

  ngOnInit() {
    this.modifyPlanDate = this._dataService.modifyPlanDate;
    this.modifyReqDate = this._dataService.modifyReqDate;
  }

  ngOnChanges() {
    this.disableForm = true;
    if(this.soLockObtained == false){
      this.inputDisableMessage = "You can't Edit, Sale Order Lock NOT obtained.";
    }
    else if (!this.purchasePOObj.isProjectLive) {
      this.inputDisableMessage = "Project is on HOLD or TO BE CANCELLED";
    }
    else if (!this.purchasePOObj.isInputEnabled) {
      this.inputDisableMessage = "This form is not yet enabled";
    }
    else if (!this._dataService.hasPOEditAccess) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
    }
    if ((this.loadCounter.marketingIP.isSplPriceApplicable ) &&
             (this.loadCounter.marketingIP.specialPriceFile.FileArray.length > 0)) {
      this.hasAdditionalMessage = true
      this.additionalMesage = "Special Price is applicable, Contact Marketing.";
    } else {
      this.hasAdditionalMessage = false;
    }
  }

  actualDateChangeHandler(_actDateHeader:string,_actDate:Date,_actDateChanged:Date,_actTokenKeyName:string,_plndDateHeader:string,_plndDate:Date,):void{
    let _actDateChangeObj:ActualDateChange = new ActualDateChange("Additional Comment", _plndDateHeader, _plndDate, _actDateHeader, 
                                                              _actDateChanged, this.purchasePOObj[_actTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _actDateChangeObj
    });
    let _prevActualDate:Date = this.purchasePOObj[_actTokenKeyName].actualDate;
    this.purchasePOObj[_actTokenKeyName].actualDate = _actDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.purchasePOObj[_actTokenKeyName].actualDate = _actDateChangeObj.actualDate;
        var changedDate: Date = null;
        if(_actDateChangeObj.actualDate != null){
          changedDate = new Date(_actDateChangeObj.actualDate.getTime());
        }
        this.purchasePOObj[_actTokenKeyName] = 
          new ActualDateToken(changedDate, true, _plndDate, _actDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.purchasePOObj[_actTokenKeyName].actualDate = _prevActualDate;
      }
    });
  }

  plannedDateChangeHandler(_plndDateHeader:string, _plndTokenKeyName:string,_plndDate:Date,_plndDateChanged:Date):void{
    let _plndDateChangeObj:ActualDateChange = new ActualDateChange("Why is the planned date changed ?", _plndDateHeader + "(existing)", 
                                                  _plndDate, _plndDateHeader + "(edited)", _plndDateChanged, this.purchasePOObj[_plndTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _plndDateChangeObj
    });
    this.purchasePOObj[_plndTokenKeyName].plannedDate = _plndDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.purchasePOObj[_plndTokenKeyName] = 
          new PlannedDateToken(new Date(_plndDateChanged.getTime()), true, null, _plndDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.purchasePOObj[_plndTokenKeyName].plannedDate = _plndDate;
      }
    });
  }

  saveSso(_submitToNextSection:boolean,ssoSubmitTo:SSOStatus = SSOStatus.Not_Started){
    if(this.updateSubSalesOrder){
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, 
          (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data),
          null,
          ssoSubmitTo
        ));
    }
  }
  deleteSSo(_deleteSO:boolean){
    if(this.updateSubSalesOrder){
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Delete_SubSale_Order));
    }
  }

  reloadData() {
    if (this.updateSubSalesOrder) {
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Reload_Data));
    }
  }

}
